module.exports = __webpack_public_path__ + "img/marron-1.fea273f9.png";